import { defineSlotRecipe } from "@chakra-ui/react";

export const fieldRecipe = defineSlotRecipe({
  base: {
    errorText: {},
    helperText: {},
    input: {
      _invalid: {
        background: "red.70",
        borderColor: "red.500",
      },
      background: "bg.subtle",
      borderWidth: "sm",
    },
    label: {
      color: "fg.muted",
      fontFamily: "body",
      fontSize: "sm",
      fontWeight: "normal",
      letterSpacing: "0%",
      lineHeight: "150%",
      textStyle: "sm/font-normal",
    },
    root: {
      "& [data-group-item]": {
        background: "bg.subtle",
        borderRadius: "xl",
      },
      "& input": {
        background: "bg.subtle",
        borderRadius: "xl",
      },
    },
  },
  slots: ["root", "label", "input", "errorText", "helperText"],
});
